(() => {
  const loader = document.querySelector('[data-mr-globo-highlights-loader]');
  if (!loader) return;

  const selector = '#gf-products [data-mr-globo-card-highlights]';
  const cache = new Map();
  const pending = new Set();
  const failed = new Set();
  const applied = new WeakMap();
  const root = loader.dataset.storeRoot.replace(/\/?$/, '/');
  let timer;
  let activeRequests = 0;

  try {
    const seed = document.querySelector('[data-mr-globo-highlight-seed]');
    Object.entries(JSON.parse(seed?.textContent || '{}')).forEach(([handle, html]) => {
      if (typeof html === 'string') cache.set(handle, html);
    });
  } catch {
    cache.clear();
  }

  function apply() {
    document.querySelectorAll(selector).forEach((mount) => {
      const handle = mount.dataset.mrProductHandle;
      if (!cache.has(handle) || applied.get(mount) === handle) return;
      const fragment = document.createElement('template');
      fragment.innerHTML = cache.get(handle);
      fragment.content.querySelector('.mr-native-highlights')?.classList.add('mr-globo-highlights');
      applied.set(mount, handle);
      mount.replaceChildren(fragment.content.cloneNode(true));
      mount.dataset.mrHighlightsComplete = 'true';
    });
  }

  async function load(handle) {
    pending.add(handle);
    activeRequests += 1;
    const url = new URL(`${root}products/${encodeURIComponent(handle)}`, window.location.origin);
    url.searchParams.set('view', 'mr-card-highlights');
    url.searchParams.set('preview_theme_id', loader.dataset.themeId);

    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Highlights unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fragment = page.querySelector('template[data-mr-card-highlight-handle]');
      if (fragment?.dataset.mrCardHighlightHandle !== handle) throw new Error('Incomplete highlights');
      cache.set(handle, fragment.innerHTML);
      apply();
    } catch {
      failed.add(handle);
      console.warn('Mr-Refurb: complete card highlights could not be loaded.');
    } finally {
      pending.delete(handle);
      activeRequests -= 1;
      schedule();
    }
  }

  function sync() {
    apply();
    const handles = [...new Set([...document.querySelectorAll(selector)]
      .map((mount) => mount.dataset.mrProductHandle)
      .filter((handle) => handle && !cache.has(handle) && !pending.has(handle) && !failed.has(handle)))];
    handles.slice(0, Math.max(0, 4 - activeRequests)).forEach(load);
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 60);
  }

  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => [...mutation.addedNodes].some((node) =>
      node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
    ))) schedule();
  }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();
